






















import CreateDialog from '@/components/CreateDialog.vue'
import { crudMixin } from '@/utils/mixins/crudMixin'
import { editMixin } from '@/utils/mixins/editMixin'
import mixins from 'vue-typed-mixins'
import { CreateCategoryDTO } from '@/utils/interfaces/delivery.interface'
import vRules from '@/utils/vRules'

export default mixins(editMixin, crudMixin).extend({
  components: { CreateDialog },
  data() {
    return {
      vRules: vRules,
      crud: {} as CreateCategoryDTO,
      defaultCrud: {
        name: '',
      },
    }
  },
  methods: {
    poster() {
      return { data: '' }
    },
  },
})
